import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, map, Observable, switchMap } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomFieldsService {

  apiDevelopment = environment.identity_url

  constructor(private http: HttpClient, private authService: AuthService) { }

  // private getAuthHeaders(): Observable<HttpHeaders> {
  //   return from(this.authService.getAccessToken()).pipe(
  //     map((token) => {
  //       if (!token) {
  //         throw new Error('Failed to acquire token');
  //       }
  //       return new HttpHeaders({
  //         Authorization: `Bearer ${token}`,
  //       });
  //     })
  //   );
  // }

  getCustomFields() {
    return this.http.get<any>(`${this.apiDevelopment}/user/me/business/custom-fields`);

    // return this.getAuthHeaders().pipe(
    //   switchMap((headers) =>
    //     this.http.get<any>(`${this.apiDevelopment}/user/me/business/custom-fields`, {
    //       headers,
    //     })
    //   ),
    // );
  }
}
